import { Accordion, AccordionSummary, Box, Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import LabelValueDisplay from "../../../../UserScreen/InventoryPage/InventorySettings/components/LabelValue/LabelValueDisplay";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import close from "../../../../asset/image/close.svg";
import deleteEnabled from "../../../../asset/image/deleteEnabled.svg";
import { channel_2GHZ, channel_5GHZ, countryCodes, HTBandwidthOptions, VHTBandwidthOptions, WifiMap, geoFencing } from "../constants";
import { useEffect, useState } from "react";
import AddButton from "../../../../UserScreen/InventoryPage/InventorySettings/components/AddButton/AddButton";
import CommonModal from "../../../../UserScreen/InventoryPage/InventorySettings/components/Modals/CommonModal";
import "./EditRouterConfig.css";

const EditRouterConfig = (props) => {
    const { editConfigOpen, handleEditConfigClose, selectedConfig, setSelectedConfig, handleSave, originalRouterConfig, ethernetIndexes, setEthernetIndexes, handleSaveEnable, newConfig } = props;
    const [formData, setFormData] = useState<any>({});
    const [generalExpanded, setGeneralExpanded] = useState(true);
    const [splitBands, setSplitBands] = useState(true);
    const [networks, setNetworks] = useState<any>(selectedConfig?.routerConfigJson?.networks || []);
    const [expandedStates, setExpandedStates] = useState<{
        network: boolean;
        options: boolean;
        dhcp: boolean;
        sandboxing: boolean;
        dns: boolean;
    }[]>([]);
    const [expandedNetworks, setExpandedNetworks] = useState<{ [key: number]: boolean }>({});

    const handleStarlinkWifiAccordionChange = (index: number) => {
        setExpandedNetworks((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    useEffect(() => {
        setNetworks(selectedConfig?.routerConfigJson?.networks)
    }, [selectedConfig?.routerConfigJson?.networks])

    const handleAddNetwork = () => {
        const newNetwork = {
            basicServiceSets: [
                {
                    ssid: "",
                    band: "RF_2GHZ",
                    authOpen: {},
                },
                {
                    ssid: "",
                    band: "RF_5GHZ",
                    authOpen: {}
                },
            ],
        };
        
        setSelectedConfig((prevConfig: any) => ({
            ...prevConfig,
            routerConfigJson: {
            ...prevConfig?.routerConfigJson,
            networks: [
                ...(prevConfig?.routerConfigJson?.networks || []),
                newNetwork,
            ],
            },
        }));
    };

    const handleDeleteNetwork = (index: number) => {
        setSelectedConfig((prevConfig: any) => {
            const networks = prevConfig?.routerConfigJson?.networks || [];
            const updatedNetworks = networks.filter((_, i) => i !== index);

            return {
            ...prevConfig,
            routerConfigJson: {
                ...prevConfig.routerConfigJson,
                networks: updatedNetworks,
            },
            };
        });
    }

    const handleTitleChange = (e: any) => {
        setSelectedConfig((prevConfig: any) => {
            return {
                ...prevConfig,
                nickname: e.target.value
            };
        });
    }

    const toggleExpand = (networkIndex: number, section: keyof typeof expandedStates[number]) => {
        setExpandedStates((prev) =>
            prev.map((state, i) =>
                i === networkIndex ? { ...state, [section]: !state[section] } : state
            )
        );
    };
    // Initialize expansion states when networks change
    useEffect(() => {
        setExpandedStates(
            selectedConfig?.routerConfigJson?.networks?.map(() => ({
                network: false,
                options: false,
                dhcp: false,
                sandboxing: false,
                dns: false,
            }))
        );
    }, [selectedConfig?.routerConfigJson?.networks]);

    const handleSplitBands = () => {
        setSplitBands(!splitBands);
    }
    const handleNetworkNameChange = (value: string, networkIndex: number, bssIndex?: number) => {
        setSelectedConfig((prev) => {
            const updated = { ...prev };
            const bssArray = updated.routerConfigJson?.networks?.[networkIndex]?.basicServiceSets;
            if (!bssArray) return prev;
            if (typeof bssIndex === "number") {
                bssArray[bssIndex] = { ...bssArray[bssIndex], ssid: value };
            } else {
                updated.routerConfigJson.networks[networkIndex].basicServiceSets = bssArray.map((bss) => ({
                    ...bss,
                    ssid: value
                }));
            }
            return updated;
        });
    }

    const handleNetworkPasswordChange = (value: string, networkIndex: number, config_key) => {
        setSelectedConfig((prev) => {
            const updated = { ...prev };
            const bssArray =
                updated.routerConfigJson?.networks?.[networkIndex]?.basicServiceSets;

            if (!bssArray) return prev;

            updated.routerConfigJson.networks[networkIndex].basicServiceSets =
                bssArray.map((bss) => {
                    if (bss[config_key]) {
                        return {
                            ...bss,
                            [config_key]: { password: value },
                        };
                    }
                    return bss;
                });

            return updated;
        });
    }

    const handleWifiSecurityChange = (e, value, networkIndex, oldConfigKey) => {
        if (value) {
            setSelectedConfig((prev) => {
                const updated = { ...prev };
                const bssArray = updated.routerConfigJson?.networks?.[networkIndex]?.basicServiceSets;
                if (!bssArray) return prev;
                updated.routerConfigJson.networks[networkIndex].basicServiceSets = bssArray.map((bss) => {
                    if (oldConfigKey) {
                        const authValue = bss[oldConfigKey];
                        const { [oldConfigKey]: _, ...rest } = bss;
                        if (value.config_key == "authOpenEncrypted" || value.config_key == "authOpen") {
                            return {
                                ...rest,
                                [value.config_key]: {}
                            }
                        }
                        else {
                            return {
                                ...rest,
                                [value.config_key]: authValue,
                            };
                        }
                    }
                    else return bss;
                });
                return updated;
            });
        }
    }

    const handleEthernetChange = (networkIndex) => {
        setEthernetIndexes((prev) => {
            if (prev.includes(networkIndex)) {
                return prev.filter((i) => i !== networkIndex);
            } else {
                return [...prev, networkIndex];
            }
        });
    }

    const handleGeneralAccordionChange = () => {
        setGeneralExpanded(!generalExpanded);
    }

    const handleChangeGeneralSetting = (field: string, value: boolean) => {
        setSelectedConfig((prev) => {
            const updatedConfig = { ...prev.routerConfigJson };

            if (value) {
                // ✅ Add/Update the key if checked
                updatedConfig[field] = true;
            } else {
                // ❌ Remove the key if unchecked
                delete updatedConfig[field];
            }

            return {
                ...prev,
                routerConfigJson: updatedConfig,
            };
        });
    };

    const handleChange = (key: string) => (e: any) => {
        const value = e.target.value;

        setSelectedConfig((prev) => {
            const updatedConfig = { ...prev.routerConfigJson };

            if (key === "countryCode") {
                if (value && value !== "Automatic") {
                    updatedConfig.applyCountryCode = true;
                    updatedConfig.countryCode = value;
                    updatedConfig.pinCountryCode = true;
                } else {
                    delete updatedConfig.applyCountryCode;
                    delete updatedConfig.countryCode;
                    delete updatedConfig.pinCountryCode;
                }
            }

            if (key === "geoFencing") {
                delete updatedConfig.onlyOverflightCountriesUsingDefault;
                delete updatedConfig.onlyOverflightCountries;

                const selected = geoFencing.find((opt) => opt.label === value);

                if (selected?.key === 'onlyOverflightCountriesUsingDefault') {
                    updatedConfig.onlyOverflightCountriesUsingDefault = true;
                } else if (selected?.key === 'onlyOverflightCountries') {
                    updatedConfig.onlyOverflightCountries = countryCodes
                        .filter((country) => country.code !== "Automatic")
                        .map((country) => country.code);
                }
            }

            if (key === "channel2ghz" || key === "channel5ghz") {
                console.log('keyyyyyyyyyyyyy', key, value)
                if (value === "Automatic") {
                    delete updatedConfig[key];
                } else {
                    updatedConfig[key] = parseInt(value);
                }
            }

            // Mapping of dropdown keys to their options
            const bandwidthOptionsMap: Record<string, any[]> = {
                htBandwidth2ghz: HTBandwidthOptions,
                htBandwidth5ghz: HTBandwidthOptions,
                vhtBandwidth: VHTBandwidthOptions,
            };

            if (bandwidthOptionsMap[key]) {
                if (value === "Default") {
                    delete updatedConfig[key]; // remove key if default
                } else {
                    const selected = bandwidthOptionsMap[key].find(opt => opt.label === value);
                    updatedConfig[key] = selected?.value;
                }
            }

            return {
                ...prev,
                routerConfigJson: updatedConfig,
            };
        });
    };

    const getGeoFencingLabel = (routerConfigJson: any) => {
        if (routerConfigJson?.onlyOverflightCountriesUsingDefault) {
            return "Commercial Aviation";
        }
        if (routerConfigJson?.onlyOverflightCountries?.length) {
            return "In-Flight Only";
        }
        return "None";
    };

    const formattedCountryOptions = countryCodes.map(({ name, code }) => ({
        code,
        name,
        display: code === "Automatic" ? "Automatic" : `${name} - ${code}`,
    }));

    const selectedCountry =
        formattedCountryOptions.find(
            (country) =>
                country.code === selectedConfig?.routerConfigJson?.countryCode
        ) ||
        formattedCountryOptions.find((country) => country.code === "Automatic") ||
        null;

    const handleCountryChange = (field: string) => (event: any, newValue: any) => {
        setSelectedConfig((prev) => {
            const updatedConfig = { ...prev.routerConfigJson };

            if (newValue && newValue.code !== "Automatic") {
                updatedConfig.applyCountryCode = true;
                updatedConfig.countryCode = newValue.code;
                updatedConfig.pinCountryCode = true;
            } else {
                delete updatedConfig.applyCountryCode;
                delete updatedConfig.countryCode;
                delete updatedConfig.pinCountryCode;
            }

            return {
                ...prev,
                routerConfigJson: updatedConfig,
            };
        });
    };

    const element = (
        <div className="ConfigForm">
            <Box className="routerConfigWifiSettings">
                <div className="wifiSettingTitle">
                    <Typography>{"Wi-Fi Settings"}</Typography>
                    <AddButton onAddClick={handleAddNetwork} addLabel="+ Add Network" maxWidth="127px" minWidth="127px" />
                </div>
                {selectedConfig?.routerConfigJson?.networks?.map((network, networkIndex) => {
                    if (!network || Object.keys(network).length === 0 || !network.basicServiceSets) {
                        return null;
                    }
                    const obj = network?.basicServiceSets?.[0];
                    const keyWithObjectValue = Object.keys(obj).find(
                        (key) => typeof obj[key] === "object" && obj[key] !== null
                    );
                    return (
                        <Box key={networkIndex} className={`networkDetails ${expandedNetworks[networkIndex] ? "networkExpanded" : ""}`}>
                            <div className="networkName">
                                <Typography>{network?.basicServiceSets[0]?.ssid}</Typography>
                                <div className="displayContents">
                                    <img src={deleteEnabled} onClick={() => handleDeleteNetwork(networkIndex)} className="deleteNetworkIcon"></img>
                                    <Accordion
                                        expanded={expandedNetworks[networkIndex]}
                                        onChange={() => handleStarlinkWifiAccordionChange(networkIndex)}
                                        square
                                        elevation={0}
                                        sx={{
                                            "&::before": { display: "none" },
                                            minWidth: "30px",
                                        }}
                                        className="wifiSettingsAccordian"
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            sx={{ minHeight: "26px", maxHeight: "26px", padding: "0px 16px" }}
                                        />
                                    </Accordion>
                                </div>
                            </div>
                            {expandedNetworks[networkIndex] && <div className="networkSettings">
                                <div>
                                    <div className="networkElement">
                                        <Typography>{"Network"}</Typography>
                                        <div className="displayContents">
                                            <Accordion
                                                expanded={expandedStates?.[networkIndex]?.network}
                                                onChange={() => toggleExpand(networkIndex, "network")}
                                                square
                                                elevation={0}
                                                sx={{
                                                    "&::before": { display: "none" },
                                                    minWidth: "30px",
                                                }}
                                                className="wifiSettingsAccordian"
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    sx={{ minHeight: "26px", maxHeight: "26px", padding: "0px 16px" }}
                                                />
                                            </Accordion>
                                        </div>
                                    </div>
                                    {expandedStates?.[networkIndex]?.network && <div>
                                        <div>
                                            {!splitBands && <div className="marginBottom8"><LabelValueDisplay
                                                label="Network Name"
                                                isInput={true}
                                                placeholder={"Network name (max 32 chars)"}
                                                value={network?.basicServiceSets[0]?.ssid}
                                                onChange={(e) => handleNetworkNameChange(e.target.value, networkIndex)}
                                                error={network?.basicServiceSets[0]?.ssid.length == 0 ? "SSID must be at least 1 character" : network?.basicServiceSets[0]?.ssid.length > 32 ? "SSID cannot exceed 32 charactes" : ""}
                                            /></div>}
                                            {splitBands && <div className="displayContents">
                                                <div className="width50">
                                                    <LabelValueDisplay
                                                        label="Network Name 2.4 GHz"
                                                        isInput={true}
                                                        placeholder={"2.4GHz name (max 32 chars)"}
                                                        value={network?.basicServiceSets[0]?.ssid}
                                                        onChange={(e) => handleNetworkNameChange(e.target.value, networkIndex, 0)}
                                                        error={network?.basicServiceSets[0]?.ssid.length == 0 ? "SSID must be at least 1 character" : network?.basicServiceSets[0]?.ssid.length > 32 ? "SSID cannot exceed 32 charactes" : ""}
                                                    />
                                                </div>
                                                <div className="width50">
                                                    <LabelValueDisplay
                                                        label="Network Name 5 GHz"
                                                        isInput={true}
                                                        placeholder={"5GHz name (max 32 chars)"}
                                                        value={network?.basicServiceSets[1]?.ssid}
                                                        onChange={(e) => handleNetworkNameChange(e.target.value, networkIndex, 1)}
                                                        error={network?.basicServiceSets[1]?.ssid.length == 0 ? "SSID must be at least 1 character" : network?.basicServiceSets[1]?.ssid.length > 32 ? "SSID cannot exceed 32 charactes" : ""}
                                                    />
                                                </div>
                                            </div>}
                                        </div>
                                        <div className="displayContents marginBottom8">
                                            <LabelValueDisplay
                                                label="Password"
                                                isPassword={true}
                                                boxWidth={452}
                                                value={keyWithObjectValue ? obj[keyWithObjectValue]?.password : ""}
                                                onChange={(e) => handleNetworkPasswordChange(e.target.value, networkIndex, keyWithObjectValue)}
                                                disabled={keyWithObjectValue === "authOpen" || keyWithObjectValue === "authOpenEncrypted"}
                                                error={keyWithObjectValue === "authOpen" || keyWithObjectValue === "authOpenEncrypted"
                                                    ? ""
                                                    : keyWithObjectValue
                                                    ? (() => {
                                                        const password = obj[keyWithObjectValue]?.password ?? "";
                                                        if (password.length === 0) return "Password cannot be empty.";
                                                        if (password.length < 8) return "Password must be at least 8 characters.";
                                                        if (password.length > 32) return "Password cannot exceed 32 characters.";
                                                        return "";
                                                    })()
                                                    : ""
                                                }
                                            />
                                        </div>
                                        <div className="displayContents marginBottom8">
                                            <LabelValueDisplay
                                                label="Split 2.4/5 GHz bands"
                                                isCheckBox={true}
                                                isChecked={splitBands}
                                                handleCheckBoxClick={handleSplitBands}
                                            />
                                        </div>
                                        <div className="displayContents">
                                            <div className="width50">
                                                <LabelValueDisplay
                                                    label="Wi-Fi Security"
                                                    isAutoComplete={true}
                                                    Value={WifiMap.find(wifi => wifi.config_key == keyWithObjectValue)}
                                                    options={WifiMap}
                                                    optionKey={"ui_id"}
                                                    handleChange={(e, value) => { handleWifiSecurityChange(e, value, networkIndex, keyWithObjectValue) }}
                                                />
                                            </div>
                                            <div className="width50 marginTop17">
                                                <LabelValueDisplay
                                                    label="Ethernet only"
                                                    isCheckBox={true}
                                                    isChecked={ethernetIndexes.includes(networkIndex)}
                                                    handleCheckBoxClick={() => handleEthernetChange(networkIndex)}
                                                    disabled={networkIndex==0}
                                                />
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                                {/* <div className="borderBottom">
                                    <div className="networkElement">
                                        <Typography>{"Networking Options"}</Typography>
                                        <div className="displayContents">
                                            <Accordion
                                                expanded={expandedStates?.[networkIndex]?.options}
                                                onChange={() => toggleExpand(networkIndex, "options")}
                                                square
                                                elevation={0}
                                                sx={{
                                                    "&::before": { display: "none" },
                                                    minWidth: "30px",
                                                }}
                                                className="wifiSettingsAccordian"
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    sx={{ minHeight: "26px", maxHeight: "26px", padding: "0px 16px" }}
                                                />
                                            </Accordion>
                                        </div>
                                    </div>
                                    {expandedStates?.[networkIndex]?.options && <div>
                                        <div className="displayContents">
                                            <div className="width50">
                                                <LabelValueDisplay
                                                    label="Subnet"
                                                    isInput={true}
                                                    placeholder={"Subnet"}
                                                    value={"Automatic"}
                                                />
                                            </div>
                                            <div className="width50">
                                                <LabelValueDisplay
                                                    label="VLAN"
                                                    isInput={true}
                                                    placeholder={"VLAN"}
                                                    value={"Automatic"}
                                                />
                                            </div>
                                        </div>
                                        <div className="displayContents">
                                            <div className="width50">
                                                <LabelValueDisplay
                                                    label="Guest"
                                                    isCheckBox={true}
                                                    isChecked={false}
                                                    handleCheckBoxClick={handleSplitBands}
                                                />
                                            </div>
                                            <div>
                                                <LabelValueDisplay
                                                    label="Hidden"
                                                    isCheckBox={true}
                                                    isChecked={false}
                                                    handleCheckBoxClick={handleSplitBands}
                                                />
                                            </div>
                                        </div>
                                        <div className="displayContents">
                                            <div className="width50">
                                                <LabelValueDisplay
                                                    label="Client Isolation"
                                                    isCheckBox={true}
                                                    isChecked={false}
                                                    handleCheckBoxClick={handleSplitBands}
                                                />
                                            </div>
                                            <div>
                                                <LabelValueDisplay
                                                    label="Disable Network when Offline"
                                                    isCheckBox={true}
                                                    isChecked={false}
                                                    handleCheckBoxClick={handleSplitBands}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <LabelValueDisplay
                                                label="Landing page"
                                                isInput={true}
                                                placeholder={"url"}
                                                value={"https://example.com"}
                                            />
                                        </div>
                                    </div>}
                                </div>
                                <div className="borderBottom">
                                    <div className="networkElement">
                                        <Typography>{"DHCP"}</Typography>
                                        <div className="displayContents">
                                            <Accordion
                                                expanded={expandedStates?.[networkIndex]?.dhcp}
                                                onChange={() => toggleExpand(networkIndex, "dhcp")}
                                                square
                                                elevation={0}
                                                sx={{
                                                    "&::before": { display: "none" },
                                                    minWidth: "30px",
                                                }}
                                                className="wifiSettingsAccordian"
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    sx={{ minHeight: "26px", maxHeight: "26px", padding: "0px 16px" }}
                                                />
                                            </Accordion>
                                        </div>
                                    </div>
                                    {expandedStates?.[networkIndex]?.dhcp && <div>
                                            <div>
                                                <LabelValueDisplay 
                                                    label="Client Isolation"
                                                    isCheckBox={true}
                                                    isChecked={false}
                                                    handleCheckBoxClick={handleSplitBands}
                                                />
                                            </div>
                                            <div style={{display: "flex", gap: "16px"}}>
                                                <div style={{width: "50%"}}>
                                                    <LabelValueDisplay 
                                                        label="DHCP Start"
                                                        isInput={true}
                                                        placeholder={"DHCP start"}
                                                        value={"20"}
                                                    />
                                                </div>
                                                <div style={{width: "50%"}}>
                                                    <LabelValueDisplay 
                                                        label="DHCP end"
                                                        isInput={true}
                                                        placeholder={"DHCP end"}
                                                        value={"65534"}
                                                    />
                                                </div>
                                            </div>
                                        </div>}
                                </div>
                                <div className="borderBottom">
                                    <div className="networkElement">
                                        <Typography>{"Sandboxing"}</Typography>
                                        <div className="displayContents">
                                            <Accordion
                                                expanded={expandedStates?.[networkIndex]?.sandboxing}
                                                onChange={() => toggleExpand(networkIndex, "sandboxing")}
                                                square
                                                elevation={0}
                                                sx={{
                                                    "&::before": { display: "none" },
                                                    minWidth: "30px",
                                                }}
                                                className="wifiSettingsAccordian"
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    sx={{ minHeight: "26px", maxHeight: "26px", padding: "0px 16px" }}
                                                />
                                            </Accordion>
                                        </div>
                                    </div>
                                </div>
                                <div className="borderBottom">
                                    <div className="networkElement">
                                        <Typography>{"DNS"}</Typography>
                                        <div className="displayContents">
                                            <Accordion
                                                expanded={expandedStates?.[networkIndex]?.dns}
                                                onChange={() => toggleExpand(networkIndex, "dns")}
                                                square
                                                elevation={0}
                                                sx={{
                                                    "&::before": { display: "none" },
                                                    minWidth: "30px",
                                                }}
                                                className="wifiSettingsAccordian"
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    sx={{ minHeight: "26px", maxHeight: "26px", padding: "0px 16px" }}
                                                />
                                            </Accordion>
                                        </div>
                                    </div>
                                </div> */}
                            </div>}
                        </Box>

                    )
                })}
            </Box>
            <Box className="routerConfigGeneralSettings">
                <Typography>{"Settings"}</Typography>
                <Box sx={{ flex: 1, margin: "4px", border: "1px solid #ebebeb", borderRadius: "4px", backgroundColor: "#fff", marginBottom: "10px", height: generalExpanded ? "450px" : "30px", padding: "0px 8px" }}>
                    <div style={{ display: "flex", gap: "16px", justifyContent: "space-between", alignItems: "center", height: "30px" }}>
                        <Typography>{"General"}</Typography>
                        <div className="displayContents">
                            <Accordion
                                expanded={generalExpanded}
                                onChange={handleGeneralAccordionChange}
                                square
                                elevation={0}
                                sx={{
                                    "&::before": { display: "none" },
                                    minWidth: "30px",
                                }}
                                className="wifiSettingsAccordian"
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    sx={{ minHeight: "26px", maxHeight: "26px", padding: "0px 16px" }}
                                />
                            </Accordion>
                        </div>
                    </div>
                    {generalExpanded && <div className="generalTitle">
                        <div className="marginBottom8">
                            <LabelValueDisplay
                                label="Country code"
                                isAutoComplete={true}
                                Value={selectedCountry}
                                options={countryCodes.map(({ name, code }) => ({
                                    code,
                                    name,
                                    display: code === "Automatic" ? "Automatic" : `${name} - ${code}`,
                                }))}
                                optionKey="display"
                                handleChange={handleCountryChange("countryCode")}
                            />
                        </div>
                        <div className="displayContents">
                            <div className="width50">
                                <LabelValueDisplay
                                    label="Disable Pending install Reboot"
                                    isCheckBox={true}
                                    isChecked={selectedConfig?.routerConfigJson?.disablePendingUpdateReboot}
                                    handleCheckBoxClick={() =>
                                        handleChangeGeneralSetting(
                                            "disablePendingUpdateReboot",
                                            !selectedConfig?.routerConfigJson?.disablePendingUpdateReboot
                                        )
                                    }
                                />
                            </div>
                            <div className="width50">
                                <LabelValueDisplay
                                    label="Bypass Mode"
                                    isCheckBox={true}
                                    isChecked={selectedConfig?.routerConfigJson?.bypassMode}
                                    handleCheckBoxClick={() =>
                                        handleChangeGeneralSetting(
                                            "bypassMode",
                                            !selectedConfig?.routerConfigJson?.bypassMode
                                        )
                                    }
                                />
                            </div>
                        </div>
                        <div>
                            <LabelValueDisplay
                                label="Geo fencing"
                                isDropdown={true}
                                value={getGeoFencingLabel(selectedConfig?.routerConfigJson)}
                                dropdownOptions={geoFencing?.map(geo => geo.label)}
                                onChange={handleChange("geoFencing")}
                            />
                        </div>
                        <div className="displayContents">
                            <div className="width50">
                                <LabelValueDisplay
                                    label="Outdoor Mode"
                                    isCheckBox={true}
                                    isChecked={selectedConfig?.routerConfigJson?.outdoorMode}
                                    handleCheckBoxClick={() =>
                                        handleChangeGeneralSetting(
                                            "outdoorMode",
                                            !selectedConfig?.routerConfigJson?.outdoorMode
                                        )
                                    }
                                />
                            </div>
                            <div className="width50">
                                <LabelValueDisplay
                                    label="DFS Enabled"
                                    isCheckBox={true}
                                    isChecked={selectedConfig?.routerConfigJson?.dfsEnabled}
                                    handleCheckBoxClick={() =>
                                        handleChangeGeneralSetting(
                                            "dfsEnabled",
                                            !selectedConfig?.routerConfigJson?.dfsEnabled
                                        )
                                    }
                                />
                            </div>
                        </div>
                        <div className="displayContents">
                            <div className="width50">
                                <LabelValueDisplay
                                    label="Disable 2.4 GHz Radio"
                                    isCheckBox={true}
                                    isChecked={selectedConfig?.routerConfigJson?.disable2ghz}
                                    handleCheckBoxClick={() =>
                                        handleChangeGeneralSetting(
                                            "disable2ghz",
                                            !selectedConfig?.routerConfigJson?.disable2ghz
                                        )
                                    }
                                />
                            </div>
                            <div className="width50">
                                <LabelValueDisplay
                                    label="Disable 5 GHz Radio"
                                    isCheckBox={true}
                                    isChecked={selectedConfig?.routerConfigJson?.disable5ghz}
                                    handleCheckBoxClick={() =>
                                        handleChangeGeneralSetting(
                                            "disable5ghz",
                                            !selectedConfig?.routerConfigJson?.disable5ghz
                                        )
                                    }
                                />
                            </div>
                        </div>
                        <div className="displayContents">
                            <LabelValueDisplay
                                label="Disable 5 GHz High Radio"
                                isCheckBox={true}
                                isChecked={selectedConfig?.routerConfigJson?.disable5ghzHigh}
                                handleCheckBoxClick={() =>
                                    handleChangeGeneralSetting(
                                        "disable5ghzHigh",
                                        !selectedConfig?.routerConfigJson?.disable5ghzHigh
                                    )
                                }
                            />
                        </div>
                        <div className="displayContents">
                            <div className="width50">
                                <LabelValueDisplay
                                    label="Channel 2.4 GHz"
                                    isDropdown={true}
                                    value={selectedConfig?.routerConfigJson?.channel2ghz || "Automatic"}
                                    dropdownOptions={channel_2GHZ}
                                    onChange={handleChange('channel2ghz')}
                                />
                            </div>
                            <div className="width50">
                                <LabelValueDisplay
                                    label="Channel 5 GHz"
                                    isAutoComplete={true}
                                    Value={
                                        selectedConfig?.routerConfigJson?.channel5ghz
                                            ? channel_5GHZ.find(
                                                ch => ch.value == selectedConfig.routerConfigJson.channel5ghz
                                            ) || channel_5GHZ.find(ch => ch.value === "Automatic")
                                            : channel_5GHZ.find(ch => ch.value === "Automatic")
                                    }
                                    options={channel_5GHZ}
                                    optionKey="value"
                                    handleChange={(e, selectedOption) => {
                                        const val = selectedOption ? selectedOption.value : "Automatic";
                                        handleChange('channel5ghz')({ target: { value: val } });
                                    }}
                                />
                            </div>
                        </div>
                        <div className="displayContents">
                            <div className="width50">
                                <LabelValueDisplay
                                    label="HT Bandwidth 2.4 GHz"
                                    isDropdown={true}
                                    value={HTBandwidthOptions.find(opt => opt.value === selectedConfig?.routerConfigJson?.htBandwidth2ghz)?.label || "Default"}
                                    dropdownOptions={HTBandwidthOptions.map(band => band.label)}
                                    onChange={handleChange("htBandwidth2ghz")}
                                />
                            </div>
                            <div className="width50">
                                <LabelValueDisplay
                                    label="HT Bandwidth 5 GHz"
                                    isDropdown={true}
                                    value={HTBandwidthOptions.find(opt => opt.value === selectedConfig?.routerConfigJson?.htBandwidth5ghz)?.label || "Default"}
                                    dropdownOptions={HTBandwidthOptions.map(band => band.label)}
                                    onChange={handleChange("htBandwidth5ghz")}
                                />
                            </div>
                        </div>
                        <div className="displayContents">
                            <LabelValueDisplay
                                label="VHT Bandwidth"
                                isDropdown={true}
                                value={VHTBandwidthOptions.find(opt => opt.value === selectedConfig?.routerConfigJson?.vhtBandwidth)?.label || "Default"}
                                dropdownOptions={VHTBandwidthOptions.map(band => band.label)}
                                onChange={handleChange("vhtBandwidth")}
                            />
                        </div>
                    </div>}

                </Box>
            </Box>
        </div>
    )

    return (
        <div>
            <CommonModal
                open={editConfigOpen}
                onClose={handleEditConfigClose}
                onSave={handleSave}
                title={newConfig ? `New Configuration *` : `Edit Configuration`}
                saveText={"Save"}
                disableSave={!handleSaveEnable()}
                showOnlineOffline={false}
                showSyncStatus={false}
                children={element}
                width={"1080px"}
                maxWidth={"1080px"}
                // height={"810px"}
                editableTitle={true}
                titleValue={`${selectedConfig?.nickname ? selectedConfig?.nickname : ""}`}
                handleTitleChange={handleTitleChange}
            />
        </div>
    )
}

export default EditRouterConfig;